module.exports = __webpack_public_path__ + "img/white-label-bg.adcde8de.png";